import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { AccordionItem } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
import { changeIconToOppositeType } from '../../common/utils/changeIconToOppositeType';
export class AccordionItemComponent extends ChameleonElementMixin(AccordionItem) {
    constructor() {
        super(...arguments);
        this.chevronPosition = 'right';
    }
    expandedChanged(_, newValue) {
        if (this.isConnected) {
            changeIconToOppositeType(this.querySelector('[slot=start]'), newValue);
        }
    }
    connectedCallback() {
        super.connectedCallback();
    }
}
__decorate([
    attr({ mode: 'boolean' })
], AccordionItemComponent.prototype, "disabled", void 0);
__decorate([
    attr({ attribute: 'chevron-position' })
], AccordionItemComponent.prototype, "chevronPosition", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'full-width' })
], AccordionItemComponent.prototype, "fullWidth", void 0);
__decorate([
    attr
], AccordionItemComponent.prototype, "divider", void 0);
